/*
 * @Author: changcheng
 * @LastEditTime: 2022-09-07 17:07:21
 */
export const titleData = [
  {
    id: 1,
    name: "主任医师",
  },
  {
    id: 2,
    name: "副主任医师",
  },
  {
    id: 3,
    name: "主治医师",
  },
  {
    id: 4,
    name: "医师",
  },
  {
    id: 5,
    name: "医士",
  },
  {
    id: 6,
    name: "主任药师",
  },
  {
    id: 7,
    name: "副主任药师",
  },
  {
    id: 8,
    name: "主管药师",
  },
  {
    id: 9,
    name: "药师",
  },
  {
    id: 10,
    name: "药士",
  },
  {
    id: 11,
    name: "主任护师",
  },
  {
    id: 12,
    name: "副主任护师",
  },
  {
    id: 13,
    name: "主管护师",
  },
  {
    id: 14,
    name: "护师",
  },
  {
    id: 15,
    name: "护士",
  },
  {
    id: 16,
    name: "主任技师",
  },
  {
    id: 17,
    name: "副主任技师",
  },
  {
    id: 18,
    name: "主管技师",
  },
  {
    id: 19,
    name: "技师",
  },
  {
    id: 20,
    name: "技士",
  },
];
